import { SHOW_TOAST, HIDE_TOAST } from "../shared/constants/fieldTypes";

export const showToast =
  (message, duration = 3000) =>
  async (dispatch) => {
    dispatch({ type: SHOW_TOAST, message });
    setTimeout(() => {
      dispatch({ type: HIDE_TOAST });
    }, duration);
  };
